import React, { Component } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import "./../../css/LoggedIn.scss";
import AVSWrapper from "./../../utils/AVSWrapper";
import NoCard from "./../../fragments/NoCard";
import ShowCard from "./../../fragments/ShowCard";
import HomeLoggedInHeader from "./../../fragments/HomeLoggedInHeader";
import RZScrollBar from "./../../fragments/RZScrollBar";
import { AlexaCommon } from "utils/Common";

const autoBind = require("auto-bind");

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cards: [],
    };

    this.avsWrapper = props.avsWrapper;
    this.avs = this.avsWrapper.avs;
    autoBind(this);
    console.log(process.env.NODE_ENV); //production development test
  }

  componentDidMount() {
    //init page
    this.initailize();
    //request Page Data from Synapse 3
    window.rzevent.triggerEvent(window.rzevent.EventTypes.REQUEST_SYNAPSE_DATA);
  }

  subscribeEvents() {
    window.rzevent.listenEvent(
      window.rzevent.EventTypes.CARD_CHANGE,
      "1",
      (card = {}) => this.onCardChange(card)
    );
    window.rzevent.listenEvent(window.rzevent.EventTypes.RENDER_CARD, "1", () =>
      this.onRenderCard()
    );
    window.rzevent.listenEvent(
      window.rzevent.EventTypes.RESPONSE_SYNAPSE_DATA,
      "1",
      (data = {}) => {
        if (data) {
          let alexaJsonObj = AlexaCommon.parseSynapseStringToJsonObj(data);
          let audioDeviceData = AlexaCommon.getSynapseSettingsAudioDeviceObj(
            alexaJsonObj
          );
          localStorage.setItem(
            "audioPanel_activeDevice",
            audioDeviceData.active
          );
        }
      }
    );
  }

  initailize() {
    //init event
    this.subscribeEvents();
    //Render Card from localStorage.
    this.onRenderCard();
  }

  refreshCardUI() {
    this.setState({
      cards: this.avs.cardManager.getCards(),
    });
  }

  onCardChange(card = {}) {
    //Refresh UI.
    this.refreshCardUI();
    //update localstorage.
    localStorage.setItem(
      "alexaCard",
      JSON.stringify(this.avs.cardManager.getCards())
    );
  }

  onRenderCard() {
    //get localstorage.
    let jsonStr = localStorage.getItem("alexaCard");
    let storedCards = JSON.parse(jsonStr);
    this.avs.cardManager.initCards(storedCards);
    //Refresh UI.
    this.refreshCardUI();
  }

  render() {
    let mainContent = "";
    if (this.state.cards) {
      // if (this.state.cards.length === 0) {
      //     mainContent = <NoCard />
      // } else {
      //     mainContent = <ShowCard cards={this.state.cards} avsWrapper={this.avsWrapper} />
      // }
      mainContent = <NoCard />;
    }

    return (
      <div className="logged-in-container" style={{ marginRight: "2px" }}>
        <div
          className="alexa-flex-column-center logged-in-content"
          style={{ height: "auto" }}
        >
          <HomeLoggedInHeader />
          <div style={{ position: "relative", height: "auto", width: "100%" }}>
            {mainContent}
          </div>
        </div>
      </div>
    );
  }
}

export default Home;
